import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from '@wix/wix-i18n-config';

import { i18n } from './i18n';
import { CampaignContext, ConfigContext } from './contexts';
import { Viewer } from './components/viewer';
import { MjmlViewer } from './components/mjml-viewer';
import {
  parseComposerData,
  prepareCampaign,
  resolveViewerKind,
} from './client-utils';
import { panorama } from './panorama';

const HtmlViewer = lazy(() => import('./components/html-viewer'));

panorama.reportLoadStart();

const config = window.__CONFIG__;
const i18nInstance = i18n(config.locale);
const message = parseComposerData(window.__CAMPAIGN__);
const kind = resolveViewerKind(message);
const campaign = prepareCampaign(message, kind);

const viewer = {
  html: () => <HtmlViewer />,
  mjml: () => <MjmlViewer customFonts={config.customFonts || undefined} />,
  classic: () => <Viewer />,
}[kind];

ReactDOM.render(
  <Suspense fallback="">
    <I18nextProvider i18n={i18nInstance}>
      <CampaignContext.Provider value={campaign}>
        <ConfigContext.Provider value={config}>
          {viewer()}
        </ConfigContext.Provider>
      </CampaignContext.Provider>
    </I18nextProvider>
  </Suspense>,
  document.getElementById('root'),
);
